module.exports = __webpack_public_path__ + "img/tcdc-logo.8357d5c1.png";